<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    w?: number | null;
    auto?: boolean;
  }>(),
  {
    w: null,
    auto: false,
  },
);

const className = computed(() => {
  if (props.auto) {
    return 'col-auto';
  }
  if (props.w) {
    return `col-${props.w}`;
  }
  return 'col';
});
</script>

<template>
  <div :class="className">
    <slot />
  </div>
</template>
